import "./main.scss";

import HomePage from "./pages/homePage";
import AboutPage from "./pages/aboutPage";
import TablePage from "./pages/tablePage";
import AdsorbedStatePage from "./pages/adsorbedStatePage";
import CatalystPathPage from "./pages/catalystPathPage";
import ReactionTablePage from "./pages/reactionTablePage";

import { Route, Routes, useLocation } from "react-router-dom";

function App() {
  let location = useLocation();

  return (
    <Routes path="*">
      <Route path="/" element={<HomePage />} />
      <Route path="/database" element={<TablePage />} />
      <Route path="/reaction_database" element={<ReactionTablePage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route
        path="/adsorbed_states/:adsorbedStateId"
        element={<AdsorbedStatePage />}
      />
      <Route
        path="/catalysts/:adsorbedStateId"
        element={<AdsorbedStatePage />}
      />
      <Route path="/catalyst_path/:reactionId" element={<CatalystPathPage />} />
    </Routes>
  );
}

export default App;
